import React from 'react';
import animationData from './lottieZiggy.json';
import Lottie from 'react-lottie';

const CzyLoaderZiggy: React.FC = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  return <Lottie options={defaultOptions} height={100} width={122} />;
};

export default React.memo(CzyLoaderZiggy);
